import React from "react";
import NascarOptimizer from "./NascarOptimizer";

export default function TrucksOptimizerPage() {
  return <NascarOptimizer forcedSeries="trucks" />;
}
